<template>
  <div class="focus-company">
    <div class="row search-input-content">
      <div class="row">
        <header-search-input
          :showArrow="false"
          class="search-input"
          :keyword="searchText"
          @searchCompany="onSearch"
          @onSuggestionItemClick="onSuggestionItemClick"
        ></header-search-input>
        <el-button class="batch-add-btn" @click="batchAddBtn">批量添加</el-button>
      </div>
      <el-button class="batch-add-btn" @click="focusGroup">管理分组</el-button>
    </div>
    <FollowCompanyList ref="followCompanyListRef" @onSuggestionItemClick="onSuggestionItemClick" :tableData="tableData" />
    <SelectCategory
      v-if="isSelectCategory"
      :checkedTag="checkedTag"
      @cancelOperation="cancelOperation"
      @continueTo="continueTo"
      @addGroup="addGroup"
    />
    <NewGroup v-if="isAddShow" @closeAddGroup="closeAddGroup" />
    <el-dialog :visible.sync="isPayAttention" width="30%" class="pay-attention-dialog">
      “{{companyName}}”已在您的关注列表中
    </el-dialog>

    <div class="match-success-dialog">
      <el-dialog
        :visible.sync="batchAddDialogVisible"
        width="352"
        :close-on-click-modal=false
        :before-close="batchAddHandleClose">
        <div v-if="matchDialogVisible" class="match-success-dialog_title">批量添加关注公司</div>
        <div v-if="!matchDialogVisible" class="match-success-dialog_title">成功匹配{{matchSuccessList.length}}家公司</div>
        <div class="company-news-list-box">
          <div v-if="matchDialogVisible" class="batch-add-textarea">
            <el-input
              type="textarea"
              resize="none"
              :rows="13"
              :placeholder="batchAddPlaceholder"
              v-model="companies">
            </el-input>
          </div>
          <div v-if="matchDialogVisible" class="batch-add-div"></div>
          <div v-if="matchDialogVisible" class="batch-add-btn">
            <el-button class="cancel-batch-add-btn" @click="onCancelBatchAddBtn">取消</el-button>
            <el-button v-if="!companies.length" class="no-batch-add-next-btn">下一步</el-button>
            <el-button v-if="companies.length" class="batch-add-next-btn" :loading="onBatchAddNextBtnLoading" @click="onBatchAddNextBtn">下一步</el-button>
          </div>
          <div v-if="!matchDialogVisible" class="match-success-list">
            <div class="match-success-list-item" v-for="(item, index) in matchSuccessList" :key="index">{{item.stock_code}}</div>
          </div>
          <div v-if="!matchDialogVisible" class="match-div"></div>
          <div v-if="!matchDialogVisible" class="match-btn">
            <el-button class="match-pre-btn" @click="onPreMatchBtn">上一步</el-button>
            <el-button v-if="matchSuccessList.length" class="import-btn" @click="onImportBtn">导入</el-button>
            <el-button v-if="!matchSuccessList.length" class="no-import-btn">导入</el-button>
          </div>
        </div>
        <div v-if="!matchDialogVisible">
          <div v-if="mismatchSuccessList.length" class="no-match-list-border"></div>
          <div v-if="mismatchSuccessList.length" class="no-match-dialog-title">未匹配{{mismatchSuccessList.length}}家公司</div>
          <div v-if="mismatchSuccessList.length" class="no-match-list">
            <div class="no-match-list-content">
              <div class="no-match-list-content-item" v-for="(item, index) in mismatchSuccessList" :key="index">{{item.stock_code}}</div>
            </div>
          </div>  
        </div>
      </el-dialog>
    </div>

    <div class="focus-group-dialog">
      <el-dialog
        :visible.sync="focusGroupDialogVisible"
        :width="focusGroupDialogWidth"
        :close-on-click-modal=false
        :before-close="focusGroupHandleClose"
      >
        <div class="focus-group-dialog_title">{{focusGroupDialogTitle}}</div>
        <div v-show="showFocusGroupType==='list'" class="company-news-list-box">
          <el-table
            :border=true
            max-height="258"
            :header-cell-style="{background: '#f7f8fc', padding: '0'}"
            :header-row-style="{height: '28px'}"
            :row-style="{height: '28px'}"
            :cell-style="{padding: '0'}"
            :data="focusGroupData"
          > 
            <el-table-column
              label="分组名称"
              width="215"
            >
              <template slot="header" slot-scope="scope">
                <div @onScope="scope">
                  <div class="header-title">分组名称</div>
                </div>
              </template>
              <template slot-scope="scope">
                <div class="title-name">{{scope.row.group_name}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="关注公司数量"
              width="116"
            >
              <template slot="header" slot-scope="scope">
                <div @onScope="scope">
                  <div class="header-title">关注公司数量</div>
                </div>
              </template>
              <template slot-scope="scope">
                <div class="title-name">{{scope.row.number}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="81"
            >
              <template slot="header" slot-scope="scope">
                <div @onScope="scope">
                  <div class="header-title">操作</div>
                </div>
              </template>
              <template slot-scope="scope">
                  <div class="operation-class">
                    <el-tooltip 
                      class="item" 
                      effect="dark" 
                      content="编辑分组" 
                      :visible-arrow="false"
                      :enterable="false"
                      popper-class="tip"
                      placement="bottom-start"
                    >
                      <i class="edit" @click="onFocusGroupEditBtnClick(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip 
                      class="item" 
                      effect="dark" 
                      content="取消关注" 
                      :visible-arrow="false"
                      :enterable="false"
                      popper-class="tip"
                      placement="bottom-start"
                    >
                      <i class="delete" @click="onFocusGroupDeleteBtnClick(scope.row)"></i>
                    </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-show="showFocusGroupType==='change'" class="change-group-name-list-box">
          <div class="change-group-name-input">
            <el-input 
              type="text" 
              :placeholder="'分组名称'" 
              v-model.trim="changeGroupNameInput"
            ></el-input>
          </div>
          <div class="change-group-name-div"></div>
          <div class="change-group-name-btn">
            <el-button class="cancel-change-group-name-btn" @click="onCancelChangeGroupNameBtn">取消</el-button>
            <el-button v-if="changeGroupNameInput" class="change-group-name-ok-btn" :loading="onChangeGroupNameBtnLoading" @click="onChangeGroupNameBtn">修改</el-button>
            <el-button v-else class="change-group-name-empty-btn">修改</el-button>
          </div>
        </div>

        <div v-show="showFocusGroupType==='cancle'" class="cancle-group-box">
          <div class="cancle-group-message">
            <div>删除分组后不可恢复，仅在本分组内的关注公司也将一并删除。</div>
          </div>
          <div class="cancle-group-div"></div>
          <div class="cancle-group-btn">
            <el-button class="cancel-cancle-group-btn" @click="onCancelCancelGroupNameBtn">取消</el-button>
            <el-button class="cancle-group-ok-btn" :loading="onCancelGroupNameBtnLoading" @click="onCancelGroupNameOkBtn">删除</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FollowCompanyList from '@/components/concern/FollowCompanyList';
import SelectCategory from '@/components/common/SelectCategory';
import NewGroup from '@/components/common/NewGroup';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import HeaderSearchInput from '@/components/common/FocusCompanyInput';

export default {
  data() {
    return {
      onBatchAddNextBtnLoading: false,
      companiesList: [],
      matchSuccessList: [],
      mismatchSuccessList: [],
      matchDialogVisible: false,
      batchAddPlaceholder: '\n每行输入一个公司，支持识别证券代码和证券简称（非上市公司请输入完整公司全称）\n\n示例:\n600919.SH\n000001.SZ\n1810.HK\n贵州茅台\n华为投资控股有限公司',
      companies: '',
      batchAddDialogVisible: false,
      ind: 0,
      searchText: undefined,
      placeholder: '添加关注公司',
      recommendWordList: [],
      isSelectCategory: false,
      isAddShow: false,
      isPayAttention: false,
      checkedTag: [],
      username: '',
      companyName: '',
      companyId: null,
      tableData: [],
      type: 'add',
      focusGroupDialogVisible: false,
      focusGroupData: [],
      changeGroupNameInput: '',
      oldGroupName: '',
      focusGroupDialogWidth: '460px',
      focusGroupDialogTitle: '管理分组', 
      showFocusGroupType: 'list',
      onChangeGroupNameBtnLoading: false,
      onCancelGroupNameBtnLoading: false
    };
  },
  watch: {
    companies() {
      if (this.companies.indexOf('。') > -1) {
        this.companies = this.companies.replace('。', '\n');
      } else if (this.companies.indexOf('，') > -1) {
        this.companies = this.companies.replace('，', '\n');
      } else if (this.companies.indexOf(' ') > -1) {
        this.companies = this.companies.replace(' ', '\n');
      } else if (this.companies.indexOf(';') > -1) {
        this.companies = this.companies.replace(';', '\n');
      } else if (this.companies.indexOf(',') > -1) {
        this.companies = this.companies.replace(',', '\n');
      } else if (this.companies.indexOf('；') > -1) {
        this.companies = this.companies.replace('；', '\n');
      } 
    }
  },
  methods: {
    onCancelCancelGroupNameBtn() {
      this.showFocusGroupType = 'list';
      this.focusGroupDialogWidth = '460px';
      this.focusGroupDialogTitle = '管理分组';
    },
    async onCancelGroupNameOkBtn() {
      this.onCancelGroupNameBtnLoading = true;
      await QuestionQuery.deleteMonitorGroupWithCompany(this.username, this.changeGroupNameInput);
      const res = await QuestionQuery.getMonitorGroupWithCompanyList(this.username);
      this.focusGroupData = res.data;
      this.onCancelGroupNameBtnLoading = false;
      this.showFocusGroupType = 'list';
      this.focusGroupDialogWidth = '460px';
      this.focusGroupDialogTitle = '管理分组';
    },
    async onChangeGroupNameBtn() {
      const params = {
        user: this.username,
        old_group: this.oldGroupName,
        new_group: this.changeGroupNameInput
      };
      this.onChangeGroupNameBtnLoading = true;
      await QuestionQuery.putMonitorGroupAndCompany(params);
      const res = await QuestionQuery.getMonitorGroupWithCompanyList(this.username);
      this.focusGroupData = res.data;
      this.onChangeGroupNameBtnLoading = false;
      this.showFocusGroupType = 'list';
      this.focusGroupDialogWidth = '460px';
      this.focusGroupDialogTitle = '管理分组';
    },
    onCancelChangeGroupNameBtn() {
      this.showFocusGroupType = 'list';
      this.focusGroupDialogWidth = '460px';
      this.focusGroupDialogTitle = '管理分组';
    },
    onFocusGroupEditBtnClick(res) {
      this.focusGroupDialogTitle = '重命名分组';
      this.focusGroupDialogWidth = '360px';
      this.showFocusGroupType = 'change';
      this.oldGroupName = res.group_name;
      this.changeGroupNameInput = res.group_name;
    },
    onFocusGroupDeleteBtnClick(res) {
      this.focusGroupDialogTitle = '删除分组';
      this.focusGroupDialogWidth = '360px';
      this.showFocusGroupType = 'cancle';
      this.changeGroupNameInput = res.group_name;
    },
    getMonitorGroupWithCompanyList() {
      QuestionQuery.getMonitorGroupWithCompanyList(this.username).then(res => {
        this.focusGroupData = res.data;
      });
    },
    focusGroup() {
      this.focusGroupDialogVisible = true;
      this.getMonitorGroupWithCompanyList();
    },
    onPreMatchBtn() {
      this.matchDialogVisible = true;
    },
    onImportBtn() {
      if (!this.matchSuccessList.length) {
        this.$message({
          message: '暂无可导入公司',
          duration: 2000,
          type: 'error'
        });
      } else {
        this.batchAddDialogVisible = false;
        this.isSelectCategory = true;
        this.type = 'batch';
      }
    },
    onCancelBatchAddBtn() {
      this.batchAddDialogVisible = false;
      this.companies = '';
    },
    onBatchAddNextBtn() {
      if (!this.companies) {
        this.$message({
          message: '内容不能为空',
          duration: 2000,
          type: 'error'
        });
      } else {
        this.companiesList = this.companies.split('\n');
        for (let i = 0; i < this.companiesList.length; i++) {
          if (this.companiesList[i] === '') {
            this.companiesList.splice(i, 1);
            i--; 
          }
        }
        if (!this.companiesList.length) {
          this.$message({
            message: '内容不能为空',
            duration: 2000,
            type: 'error'
          });
          return;
        }
        this.onBatchAddNextBtnLoading = true;
        QuestionQuery.companyMatch(this.companiesList).then(res => {
          this.onBatchAddNextBtnLoading = false;
          this.matchSuccessList = res.match;
          this.mismatchSuccessList = res.mismatch;
          this.matchDialogVisible = false;
        });
      }
    },
    batchAddHandleClose() {
      this.batchAddDialogVisible = false;
      this.companies = '';
    },
    focusGroupHandleClose() {
      if (this.showFocusGroupType === 'cancle' || this.showFocusGroupType === 'change') {
        this.showFocusGroupType = 'list';
        this.focusGroupDialogWidth = '460px';
        this.focusGroupDialogTitle = '管理分组';
      } else {
        this.focusGroupDialogVisible = false;
        this.$refs.followCompanyListRef.refreshData();
      }
    },
    batchAddBtn() {
      this.companies = '';
      this.batchAddDialogVisible = true;
      this.matchDialogVisible = true;
    },
    onSearch() {
      this.searchTermsRecommend();
    },
    onSuggestionItemClick(obj) {
      this.companyName = obj.name;
      this.companyId = obj.id;
      if (obj.type && obj.type === 'search') {
        QuestionQuery.payAttentionToCompany(this.username, obj.id).then(
          res => {
            if (res.existed) {
              this.isPayAttention = true;
            } else {
              this.checkedTag = [];
              this.type = 'add';
              this.isSelectCategory = true;
            }
          }
        );
      } else {
        this.type = 'change';
        this.checkedTag = obj.groups;
        this.isSelectCategory = true;
      }
    },
    cancelOperation() {
      this.isSelectCategory = false;
      this.tableData = [];
      this.checkedTag = [];
    },
    continueTo(tag = []) {
      this.isSelectCategory = false;
      this.checkedTag = [];
      if (this.type === 'add') {
        QuestionQuery.addMonitorGroup(
          this.username,
          this.companyId,
          tag
        ).then(
          () => {
            this.tableData = [];
            document.getElementsByClassName(
              'el-table__body-wrapper'
            )[0].scrollTop = 0;
          },
          () => {
            this.$message.error('添加关注失败！');
          }
        );
      } else if (this.type === 'batch') {
        const matchSuccessListData = this.matchSuccessList.map(item => item.name);
        QuestionQuery.batchMonitorCompanies(this.username, matchSuccessListData, tag).then(() => {
          this.$refs.followCompanyListRef.refreshData();
        });
      } else {
        QuestionQuery.updateMonitor(this.username, this.companyName, tag).then(
          () => {
            this.tableData = [];
          },
          () => {
            this.$message.error('编辑分组失败！');
          }
        );
      }
    },
    addGroup() {
      this.isSelectCategory = false;
      this.isAddShow = true;
    },
    closeAddGroup(value) {
      this.checkedTag = [].concat(value);
      this.isAddShow = false;
      this.isSelectCategory = true;
    }
  },
  mounted() {
    this.username = authService.getLoggedUserName();
  },
  components: {
    FollowCompanyList,
    SelectCategory,
    NewGroup,
    HeaderSearchInput
  }
};
</script>

<style lang="scss" scoped>
.header-title {
  color: #747990;
  font-weight: 400;
}
.operation-class {
    display: flex;
    justify-content: space-around;
    .edit {
      display: inline-block;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background-color: transparent;
      background-image: url("../../assets/img/edit-icon.svg");
      background-size: 100% 100%;
      align-items: center;
      cursor: pointer;
      &:hover {
        background-image: url("../../assets/img/edit-icon-hover.svg");
      }
    }
    .delete {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-left: 6px;
      background-color: transparent;
      background-image: url("../../assets/img/delete-icon.svg");
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        border-radius: 2px;
        background-image: url("../../assets/img/delete-icon-hover.svg");
      }
    }
    .edit-hover {
      height: 24px;
      padding: 3px 17px 5px 0px;
      &:hover {
        border-radius: 2px;
      }
      &:active {
        border-radius: 2px;
      }
      .edit {
        display: inline-block;
        width: 16px;
        height: 16px;
        line-height: 16px;
        background-color: transparent;
        background-image: url("../../assets/img/edit-icon.svg");
        background-size: 100% 100%;
        align-items: center;
        cursor: pointer;
        &:hover {
          background-image: url("../../assets/img/edit-icon-hover.svg");
        }
      }
    }
    .delete-hover {
      height: 24px;
      padding: 3px 4px 5px 0px;
      &:hover {
        border-radius: 2px;
      }
      &:active {
        border-radius: 2px;
      }
      .delete {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-color: transparent;
        background-image: url("../../assets/img/delete-icon.svg");
        background-size: 100% 100%;
        cursor: pointer;
        &:hover {
          border-radius: 2px;
          background-image: url("../../assets/img/delete-icon-hover.svg");
        }
      }
    }
  }
.focus-company {
  position: relative;
  padding-bottom: 24px;
}
.search-input-content {
  justify-content: space-between;
  height: 34px;
  padding: 24px;
  margin-bottom: 16px;
  .batch-add-btn {
    margin-top: -1px;
    margin-left: 10px;
    height: 26px;
    width: 80px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
    color: #464d6c;
    background-color: #f7f8fc;
    font-weight: 400;
    &:hover {
      color: #464d6c;
      background-color: #eaebef;
    }
    &:focus {
      color: #464d6c;
      background-color: #eaebef;
    }
    &:active {
      color: #464d6c;
      background-color: #eaebef;
    }
  }
}
.input-container {
  position: relative;
  width: 271px;
  height: 26px;
  margin: 24px 24px 12px;
  input {
    width: 100%;
    padding: 5px 46px 5px 12px;
    font-size: 14px;
    border-radius: 4px;
    background-color: #f7f8fc;
    border: none;
    outline: none;
  }
  input[placeholder] {
    color: #747990 !important;
  }
  .search-button {
    position: absolute;
    top: 0px;
    right: 2px;
    padding: 5px 16px;
    width: 46px;
    border: none;
    background-color: #f7f8fc;
    span {
      display: block;
    }

    .icon-search {
      display: inline-block;
      width: 14px;
      height: 14px;
      background-image: url("../../assets/img/search2.svg");
      background-size: 100% 100%;
    }
  }
}
.result-container {
  width: 271px;
  background-color: #ffffff;
  box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
  border-radius: 2px;
  border: solid 1px #f7f7fa;
  padding: 8px 0 16px;
  position: absolute;
  left: 24px;
  top: 28px;
  z-index: 3;
  .result-list {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    li {
      display: flex;
      justify-content: space-between;
      padding-left: 12px;
      color: #464d6c;
      cursor: pointer;

      &:hover {
        background-color: #45a8cc;
        color: #ffffff;
      }

      .item-value {
        overflow: hidden;
        display: inline-block;
        width: 580px;
        height: 28px;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 28px;
      }
      .img {
        margin: 8px 16px 0 0;
        width: 16px;
        height: 16px;
        opacity: 0.2;
        &:hover {
          opacity: 1;
        }
      }
    }
  }
}
/deep/ .pay-attention-dialog {
  .el-dialog {
    background-color: #ffffff;
    border-radius: 0;
    width: 400px;
    height: 165px;
    position: relative;
    top: 100px;
    .el-dialog__headerbtn {
      top: 14px;
    }
    .el-dialog__header {
      padding: 0;
      height: 44px;
      box-shadow: inset 0px -1px 0px 0px #f7f7fa;
      padding: 0 24px;
      .el-dialog__title {
        color: #171f46;
        font-size: 14px;
        line-height: 44px;
      }
    }
    .el-dialog__body {
      padding: 24px;
      margin-top: 44px;
      color: #747990;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
    }
  }
}
.match-success-dialog {
    &_title {
      height: 44px;
      line-height: 44px;
      padding-left: 24px;
      font-size: 14px;
      color:#171f46;
      font-weight:500;
      background: #ffffff;
      box-shadow: inset 0px -1px 0px 0px #f7f7fa;
    }
    .company-news-list-box {
      padding-top: 10px;
      height: 375px;
      background: #ffffff;
      .batch-add-textarea {
        padding: 0 24px;
      }
      .batch-add-div {
        height: 16px;
        box-shadow: inset 0px -1px 0px 0px#f7f7fa;
      }
      .batch-add-btn {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        .cancel-batch-add-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          font-weight: 400;
          &:hover {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:focus {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:active {
            color: #464d6c;
            background-color: #eaeaed;
          }
        }
        .batch-add-next-btn {
          height: 32px;
          width: 74px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #ffffff;
          background-color: #45a8cc;
          font-weight: 400;
          &:hover {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:focus {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:active {
            color: #ffffff;
            background-color: #3e97b8;
          }
        }
        .no-batch-add-next-btn {
          height: 32px;
          width: 74px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #ffffff;
          background-color: rgba(69, 168, 204, 0.4);
          font-weight: 400;
          cursor: auto;
          &:hover {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
          &:focus {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
          &:active {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
        }
      }
      .match-success-list {
        padding:0 24px;
        height: 290px;
        overflow: auto;
        .match-success-list-item {
          padding: 5px 0;
          color: #464d6c;
          font-size: 14px;
        }
      }
      .match-div {
        height: 10px;
        box-shadow: inset 0px -1px 0px 0px#f7f7fa;
      }
      .match-btn {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        .match-pre-btn {
          height: 32px;
          width: 74px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          font-weight: 400;
          &:hover {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:focus {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:active {
            color: #464d6c;
            background-color: #eaeaed;
          }
        }
        .import-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #ffffff;
          background-color: #45a8cc;
          font-weight: 400;
          &:hover {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:focus {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:active {
            color: #ffffff;
            background-color: #3e97b8;
          }
        }
        .no-import-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #ffffff;
          background-color: rgba(69, 168, 204, 0.4);
          font-weight: 400;
          cursor: auto;
          &:hover {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
          &:focus {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
          &:active {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
        }
      }
    }
    .no-match-list-border {
      border-top: 1px solid transparent;
    }
    .no-match-dialog-title {
      height: 44px;
      line-height: 44px;
      padding-left: 24px;
      font-size: 14px;
      color:#171f46;
      font-weight:500;
      background: #ffffff;
      box-shadow: inset 0px -1px 0px 0px #f7f7fa;
    }
    .no-match-list {
      padding: 10px 24px;
      background: #ffffff;
      .no-match-list-content {
        height: 97px;
        overflow: auto;
        .no-match-list-content-item {
          padding: 5px 0;
          color: #ff5b65;
          font-size: 14px;
        }
      }
    }
    /deep/ .el-dialog__wrapper {
      .el-dialog {
        width: 440px;
        position: relative;
        margin-top: 25vh !important;
        border-radius: 8px;
        .el-dialog__header {
          position: absolute;
          top: 0;
          right: 0px;
          .el-dialog__headerbtn {
            width: 24px;
            height: 24px;
            top: 14px;
            .el-dialog__close {
              color: #514d4f;
            }
          }
        }
        .el-dialog__body {
          padding: 0;
          .el-textarea {
            .el-textarea__inner {
              margin-bottom: 0;
              background-color: #f7f8fc;
              border-radius: 2px;
              border: none;
              color: #747990;
            }
          }
        }
      }
    }
  }
  .focus-group-dialog {
    &_title {
      height: 44px;
      line-height: 44px;
      padding-left: 24px;
      font-size: 14px;
      color:#171f46;
      font-weight:500;
      background: #ffffff;
      box-shadow: inset 0px -1px 0px 0px #f7f7fa;
    }
    .company-news-list-box {
      padding: 16px 24px 20px;
      height: 292px;
      background: #ffffff;
    }
    .change-group-name-list-box {
      height: 185px;
      .change-group-name-input {
        padding: 16px 24px 0;
        height: 121px;
        /deep/ .el-input {
          width: 100%;
          height: 32px;
          border-radius: 2px;
          margin-top: 9px;
          .el-input__inner {
            height: 100%;
            border: none;
            background: #f7f8fc;
            color: #171f46;
            font-size: 14px;
            padding: 3px 12px;
          }
          .el-input__count .el-input__count-inner {
            background: #f7f8fc;
          }
          .el-input__inner::placeholder{
            color: #D1D2DA;
          }
          .el-input__inner::-webkit-input-placeholder{
            color: #D1D2DA;
          }
          .el-input__inner::-moz-placeholder{   /* Mozilla Firefox 19+ */
            color: #D1D2DA;
          }
          .el-input__inner:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
            color: #D1D2DA;
          }
          .el-input__inner:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
            color: #D1D2DA;
          }
        }
      }
      .change-group-name-div {
        height: 1px;
        box-shadow: inset 0px -1px 0px 0px#f7f7fa;
      }
      .change-group-name-btn {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        .cancel-change-group-name-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          font-weight: 400;
          &:hover {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:focus {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:active {
            color: #464d6c;
            background-color: #eaeaed;
          }
        }
        .change-group-name-ok-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #ffffff;
          background-color: #45a8cc;
          font-weight: 400;
          &:hover {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:focus {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:active {
            color: #ffffff;
            background-color: #3e97b8;
          }
        }
        .change-group-name-empty-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #ffffff;
          background-color: rgba(69, 168, 204, 0.4);
          font-weight: 400;
          cursor: auto;
          &:hover {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
          &:focus {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
          &:active {
            color: #ffffff;
            background-color: rgba(69, 168, 204, 0.4);
          }
        }
      }
    }
    .cancle-group-box {
      height: 185px;
      .cancle-group-message {
        padding: 24px;
        height: 121px;
        color: #747990;
        font-size: 14px;
      }
      .cancle-group-div {
        height: 1px;
        box-shadow: inset 0px -1px 0px 0px#f7f7fa;
      }
      .cancle-group-btn {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        .cancel-cancle-group-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          font-weight: 400;
          &:hover {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:focus {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:active {
            color: #464d6c;
            background-color: #eaeaed;
          }
        }
        .cancle-group-ok-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          border-radius: 2px;
          border: none;
          font-size: 14px;
          color: #ffffff;
          background-color: #ff5b65;
          font-weight: 400;
          &:hover {
            color: #ffffff;
            background-color: #e6525b;
          }
          &:focus {
            color: #ffffff;
            background-color: #e6525b;
          }
          &:active {
            color: #ffffff;
            background-color: #e6525b;
          }
        }
      }
    }
    /deep/ .el-dialog__wrapper {
      .el-dialog {
        position: relative;
        margin-top: 25vh !important;
        border-radius: 8px;
        .el-dialog__header {
          position: absolute;
          top: 0;
          right: 0px;
          .el-dialog__headerbtn {
            width: 24px;
            height: 24px;
            top: 14px;
            .el-dialog__close {
              color: #514d4f;
            }
          }
        }
        .el-dialog__body {
          padding: 0;
        }
      }
    }
  }
  input::-webkit-input-placeholder{
    color: #D1D2DA;
  }
  input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color: #D1D2DA;
  }
  input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color: #D1D2DA;
  }
  input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
    color: #D1D2DA;
  }
</style>
